<template>
  <v-card>
    <v-card-title>{{
      value.nuova_prenotazione
        ? "Crea Template"
        : value.modifica_prenotazione
        ? "Modifica Template"
        : `Template n. ${value.id_template}`
    }}</v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12" class="py-0">
            <p class="pt-4 mb-2 fake-card-title">Dati prenotazione</p>
          </v-col>
          <v-col cols="12" sm="6" class="py-0">
            <v-autocomplete
              label="Cliente"
              v-model="value.id_cliente"
              :items="$store.getters.getClientiAttivi"
              item-value="id_cliente"
              item-text="ragione_sociale"
              :rules="obbligatorio_roule"
              no-data-text="Nessun dato disponibile"
              :readonly="
                !value.nuova_prenotazione && !value.modifica_prenotazione
              "
              @change="setComparto"
            />
            <v-text-field
              label="Numero bancali"
              v-model="value.bancali"
              :rules="[...bancali_obbligatori_roule, ...solo_numeri_roule]"
              :readonly="
                !value.nuova_prenotazione && !value.modifica_prenotazione
              "
              :maxlength="3"
              counter="3"
            />
          </v-col>
          <v-col cols="12" sm="6" class="py-0">
            <v-autocomplete
              label="Tipo scarico"
              v-model="value.id_tipo_scarico"
              :items="$store.getters.getTipiScaricoAttivi"
              item-value="id_tipo_scarico"
              item-text="descrizione"
              :rules="zero_obbligatorio_roule"
              :readonly="
                !value.nuova_prenotazione && !value.modifica_prenotazione
              "
            />
            <v-text-field
              label="Documento di riferimento"
              v-model="value.riferimento_documento"
              :rules="obbligatorio_roule"
              :readonly="
                !value.nuova_prenotazione && !value.modifica_prenotazione
              "
              :maxlength="20"
              counter="20"
            />
          </v-col>
          <v-col cols="12" sm="6" class="py-0">
            <v-select
              label="Comparto"
              v-model="value.id_comparto"
              :items="$store.getters.getCompartiAttivi"
              item-value="id_comparto"
              item-text="codice"
              :rules="zero_obbligatorio_roule"
              :readonly="
                !value.nuova_prenotazione && !value.modifica_prenotazione
              "
            />
          </v-col>
          <v-col class="py-0" cols="12" sm="6">
            <v-text-field
              label="Mittente"
              v-model="value.mittente"
              :maxlength="40"
              counter="40"
              :readonly="
                !value.nuova_prenotazione && !value.modifica_prenotazione
              "
            />
          </v-col>
          <v-col cols="12" class="py-0">
            <v-textarea
              label="Indicazioni per lo scarico"
              v-model="value.indicazioni_scarico"
              rows="2"
              :readonly="
                !value.nuova_prenotazione && !value.modifica_prenotazione
              "
              :rules="[...rule_caratteri, checkLenIndScarico]"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="py-0">
            <p class="pt-4 mb-2 fake-card-title">Informazioni sul vettore</p>
            <!-- Con combobox il valore viene aggiornato solo al blur o alla scelta del elemento. @input.native serve per ovviare a questo problema e abilitare i campi senza aspettare quegli eventi -->
            <v-combobox
              label="Ragione sociale"
              v-model="value.rag_soc_vettore"
              :items="$store.getters.getVettoriAttivi"
              item-value="id_cliente"
              item-text="ragione_sociale"
              :maxlength="40"
              counter="40"
              :rules="obbligatorio_roule"
              @change="resetVettore()"
              @input.native="rag_soc_vettore_native = $event.srcElement.value"
              :readonly="
                !value.nuova_prenotazione && !value.modifica_prenotazione
              "
            />
          </v-col>
          <v-col cols="12" sm="6" class="py-0">
            <v-combobox
              label="Persona di riferimento"
              v-model="value.nome_riferimento_vettore"
              :disabled="!rag_soc_vettore_native && !value.rag_soc_vettore"
              :readonly="
                !value.nuova_prenotazione && !value.modifica_prenotazione
              "
              :items="filteredUsers"
              item-text="nome"
              @change="completaCampi()"
              :maxlength="60"
              counter="60"
              :rules="obbligatorio_roule"
            />
          </v-col>
          <v-col cols="12" sm="6" class="py-0">
            <v-text-field
              label="Telefono"
              v-model="value.tel_nascosto"
              :disabled="!rag_soc_vettore_native && !value.rag_soc_vettore"
              :maxlength="15"
              counter="15"
              :rules="[
                () =>
                  !value.telefono_riferimento_vettore ||
                  !isNaN(value.telefono_riferimento_vettore) ||
                  'Inserire un numero valido!',
                () =>
                  !value.telefono_riferimento_vettore ||
                  !value.telefono_riferimento_vettore.includes('.') ||
                  'Il campo consente solo numeri!',
                () =>
                  !value.telefono_riferimento_vettore ||
                  !value.telefono_riferimento_vettore.includes(',') ||
                  'Il campo consente solo numeri!',
                () =>
                  !value.telefono_riferimento_vettore ||
                  !value.telefono_riferimento_vettore.includes('-') ||
                  'Il campo consente solo numeri!',
                () =>
                  !value.telefono_riferimento_vettore ||
                  !value.telefono_riferimento_vettore.includes('+') ||
                  'Il campo consente solo numeri!',
                () =>
                  !value.telefono_riferimento_vettore ||
                  !value.telefono_riferimento_vettore.includes('e') ||
                  'Il campo consente solo numeri!',
                () =>
                  !value.telefono_riferimento_vettore ||
                  !value.telefono_riferimento_vettore.includes('E') ||
                  'Il campo consente solo numeri!',
                () =>
                  !value.telefono_riferimento_vettore ||
                  !value.telefono_riferimento_vettore.includes('/') ||
                  'Il campo consente solo numeri!',
              ]"
              @input="handleInputTel"
              :readonly="
                !value.nuova_prenotazione && !value.modifica_prenotazione
              "
            />
          </v-col>
          <v-col class="py-0" cols="12">
            <v-text-field
              label="Email"
              v-model="value.email_nascosta"
              :disabled="!rag_soc_vettore_native && !value.rag_soc_vettore"
              :maxlength="60"
              counter="60"
              :rules="[
                () =>
                  !value.email_riferimento_vettore ||
                  /^[^*@\s]+@[^*@\s]+\.[^*@\s]+$/.test(
                    value.email_riferimento_vettore
                  ) ||
                  'E-mail non valida!',
                ...obbligatorio_roule,
              ]"
              @input="handleInputEmail"
              :readonly="
                !value.nuova_prenotazione && !value.modifica_prenotazione
              "
            />
          </v-col>
          <v-col cols="12" class="py-0">
            <v-textarea
              label="Note generali"
              v-model="value.note"
              rows="3"
              :readonly="
                !value.nuova_prenotazione && !value.modifica_prenotazione
              "
              :rules="[...rule_caratteri, checkLenNote]"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-row>
              <v-col cols="12" class="py-0">
                <p class="pt-4 mb-2 fake-card-title">Giorni e orario</p>
                <v-chip-group
                  v-model="value.giorni"
                  active-class="primary"
                  multiple
                >
                  <v-chip
                    v-for="(giorno, i) in giorni"
                    :key="i"
                    :value="giorno.value"
                    :disabled="
                      !value.nuova_prenotazione && !value.modifica_prenotazione
                    "
                  >
                    {{ giorno.text }}
                  </v-chip>
                </v-chip-group>
                <p
                  style="font-size: 12px; margin-bottom: 0"
                  v-if="value.nuova_prenotazione || value.modifica_prenotazione"
                >
                  Selezionare almeno un giorno
                </p>
              </v-col>
              <v-col cols="12" sm="6" class="py-0">
                <v-select
                  v-model="value.fascia"
                  label="Fascia oraria"
                  :items="oreDisponibili"
                  :rules="obbligatorio_roule"
                  no-data-text="Nessuna fascia oraria disponibile"
                  v-if="value.nuova_prenotazione || value.modifica_prenotazione"
                />
                <v-text-field
                  v-model="value.fascia"
                  label="Fascia oraria"
                  readonly
                  v-if="
                    !value.nuova_prenotazione && !value.modifica_prenotazione
                  "
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            v-if="!value.nuova_prenotazione && !value.modifica_prenotazione"
          >
            <v-row>
              <v-col cols="12" class="py-0">
                <p class="pt-4 mb-2 fake-card-title">
                  Ultimi 4 periodi schedulati:
                </p>
                <span v-for="(periodo, i) in periodiDaMostrare" :key="i">
                  {{ formattedData(periodo.data_inizio) }} -
                  {{ formattedData(periodo.data_fine) }}<br />
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="secondary" text @click="closeDialog">
        {{
          value.nuova_prenotazione || value.modifica_prenotazione
            ? "Annulla"
            : "Chiudi"
        }}
      </v-btn>
      <v-btn
        color="primary"
        text
        @click="savePrenotazione"
        :disabled="loading || !valid"
        :loading="loading"
        v-if="value.nuova_prenotazione || value.modifica_prenotazione"
      >
        Salva
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    valid: true,
    loading: false,
    rag_soc_vettore_native: "",
    giorni: [
      { text: "Lun", value: 1 },
      { text: "Mar", value: 2 },
      { text: "Mer", value: 3 },
      { text: "Gio", value: 4 },
      { text: "Ven", value: 5 },
      // { text: "Sab", value: 6 },
      // { text: "Dom", value: 0 },
    ],
    oreDisponibili: [],
    obbligatorio_roule: [(v) => !!v || "Campo obbligatorio!"],
    zero_obbligatorio_roule: [(v) => !!v || v == 0 || "Campo obbligatorio"],
    bancali_obbligatori_roule: [
      (v) => !!v || "Campo obbligatorio!",
      (v) => v > 0 || "Numero non valido",
      (v) => v % 1 == 0 || "Numero non valido",
    ],
    solo_numeri_roule: [
      (v) => !v || !isNaN(v) || "Inserire un numero valido!",
      (v) => !v || !v.includes(".") || "Il campo consente solo numeri!",
      (v) => !v || !v.includes(",") || "Il campo consente solo numeri!",
      (v) => !v || !v.includes("-") || "Il campo consente solo numeri!",
      (v) => !v || !v.includes("+") || "Il campo consente solo numeri!",
      (v) => !v || !v.includes("e") || "Il campo consente solo numeri!",
      (v) => !v || !v.includes("E") || "Il campo consente solo numeri!",
      (v) => !v || !v.includes("/") || "Il campo consente solo numeri!",
    ],
    edit_rules_email: [
      (v) => !v || /.+@.+\..+/.test(v) || "E-mail non valida!",
    ],
    rule_caratteri: [
      (v) =>
        !v ||
        !v.match(/[^\x0A\x0D\xE0\xE9\xE8\xEC\xF2\xF9\x20-\x7e]/gm) || //  \n à è é ì ò ù e tutto il normale ASCII
        `Presenti dei caratteri non permessi`,
    ],
  }),
  props: ["value"],
  methods: {
    closeDialog() {
      this.$emit("close-dialog");
      this.$refs.form.reset();
    },
    savePrenotazione() {
      this.$refs.form.validate();
      this.$nextTick(() => {
        if (
          !this.valid ||
          this.value.giorni.length == 0 ||
          (this.value.fascia && this.value.fascia.length == 0)
        ) {
          return;
        }

        if (this.value.nuova_prenotazione) {
          this.creaPrenotazione();
        }

        if (this.value.modifica_prenotazione) {
          this.modificaPrenotazione();
        }
      });
    },
    creaPrenotazione() {
      this.loading = true;

      var id_vettore = null;
      var rag_soc_vettore = this.value.rag_soc_vettore;
      var nome_riferimento_vettore = this.value.nome_riferimento_vettore;

      if (
        typeof this.value.rag_soc_vettore == "object" &&
        this.value.rag_soc_vettore != null
      ) {
        id_vettore = this.value.rag_soc_vettore.id_cliente;
        rag_soc_vettore = this.value.rag_soc_vettore.ragione_sociale;
      }

      if (
        typeof this.value.nome_riferimento_vettore == "object" &&
        this.value.nome_riferimento_vettore != null
      ) {
        nome_riferimento_vettore = this.value.nome_riferimento_vettore.nome;
      }

      this.axios
        .post(`${this.$store.state.endpoint}/template-prenotazioni`, {
          id_cliente: this.value.id_cliente,
          id_tipo_scarico: this.value.id_tipo_scarico,
          bancali: this.value.bancali,
          riferimento_documento: this.value.riferimento_documento,
          id_comparto: this.value.id_comparto,
          indicazioni_scarico: this.value.indicazioni_scarico,
          id_vettore: id_vettore,
          rag_soc_vettore: rag_soc_vettore,
          mittente: this.value.mittente,
          nome_riferimento_vettore: nome_riferimento_vettore,
          telefono_riferimento_vettore: this.value.telefono_riferimento_vettore,
          email_riferimento_vettore: this.value.email_riferimento_vettore,
          note: this.value.note,
          giorni: this.value.giorni.sort().join(),
          fascia: this.value.fascia,
        })
        .then(() => {
          this.$store.state.snackbar = true;
          this.$store.state.snackbar_text = "Template creato con successo!";
          this.$store.state.snackbar_color = "success";

          this.$emit("update-prenotazioni");
          this.closeDialog();
        })
        .catch((e) => {
          this.$store.state.snackbar_text =
            "Non è stato possibile creare il template";

          if (
            e.response &&
            e.response.data &&
            e.response.data.message &&
            typeof e.response.data.message === "string"
          ) {
            this.$store.state.snackbar_text += ": " + e.response.data.message;
          } else {
            this.$store.state.snackbar_text +=
              ". Verifica la connessione internet o riprova più tardi";
          }

          this.$store.state.snackbar = true;
          this.$store.state.snackbar_color = "error";
          console.log("Errore template prenotazioni", e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    modificaPrenotazione() {
      this.loading = true;

      var id_vettore = null;
      var rag_soc_vettore = this.value.rag_soc_vettore;
      var nome_riferimento_vettore = this.value.nome_riferimento_vettore;

      if (
        typeof this.value.rag_soc_vettore == "object" &&
        this.value.rag_soc_vettore != null
      ) {
        id_vettore = this.value.rag_soc_vettore.id_cliente;
        rag_soc_vettore = this.value.rag_soc_vettore.ragione_sociale;
      }

      if (
        typeof this.value.nome_riferimento_vettore == "object" &&
        this.value.nome_riferimento_vettore != null
      ) {
        nome_riferimento_vettore = this.value.nome_riferimento_vettore.nome;
      }

      this.axios
        .put(`${this.$store.state.endpoint}/template-prenotazioni`, {
          id_template: this.value.id_template,
          id_cliente: this.value.id_cliente,
          id_tipo_scarico: this.value.id_tipo_scarico,
          bancali: this.value.bancali,
          riferimento_documento: this.value.riferimento_documento,
          id_comparto: this.value.id_comparto,
          indicazioni_scarico: this.value.indicazioni_scarico,
          id_vettore: id_vettore,
          rag_soc_vettore: rag_soc_vettore,
          mittente: this.value.mittente,
          nome_riferimento_vettore: nome_riferimento_vettore,
          telefono_riferimento_vettore: this.value.telefono_riferimento_vettore,
          email_riferimento_vettore: this.value.email_riferimento_vettore,
          note: this.value.note,
          giorni: this.value.giorni.sort().join(),
          fascia: this.value.fascia,
        })
        .then(() => {
          this.$store.state.snackbar = true;
          this.$store.state.snackbar_text = "Template modificato con successo!";
          this.$store.state.snackbar_color = "success";

          this.$emit("update-prenotazioni");
          this.closeDialog();
        })
        .catch((e) => {
          this.$store.state.snackbar_text =
            "Non è stato possibile modificare il template";

          if (
            e.response &&
            e.response.data &&
            e.response.data.message &&
            typeof e.response.data.message === "string"
          ) {
            this.$store.state.snackbar_text += ": " + e.response.data.message;
          } else {
            this.$store.state.snackbar_text +=
              ". Verifica la connessione internet o riprova più tardi";
          }

          this.$store.state.snackbar = true;
          this.$store.state.snackbar_color = "error";
          console.log("Errore template prenotazioni", e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //  Propongo il comparto di default del cliente selezionato (per admin)
    setComparto() {
      if (
        this.$store.getters.getClientiAttivi.filter(
          (e) => e.id_cliente == this.value.id_cliente
        ).length > 0
      ) {
        this.value.id_comparto = this.$store.getters.getClientiAttivi.filter(
          (e) => e.id_cliente == this.value.id_cliente
        )[0]["id_comparto"];
      }
    },
    //  Richiesta di Mattia di resettare i campi del vettore quando viene cambiata la ragione sociale
    resetVettore() {
      if (this.value.nome_riferimento_vettore) {
        this.value.nome_riferimento_vettore = "";
      }

      if (this.value.telefono_riferimento_vettore) {
        this.value.telefono_riferimento_vettore = "";
      }

      if (this.value.email_riferimento_vettore) {
        this.value.email_riferimento_vettore = "";
      }
    },
    //  Compilo automaticamente i campi del vettore se scelto dal menu a tendina
    completaCampi() {
      if (
        typeof this.value.nome_riferimento_vettore == "object" &&
        this.value.nome_riferimento_vettore != null
      ) {
        this.value.telefono_riferimento_vettore =
          this.value.nome_riferimento_vettore.telefono;
        this.value.email_riferimento_vettore =
          this.value.nome_riferimento_vettore.email;

        //  Nascondo email
        var idEmail = this.value.email_riferimento_vettore.indexOf("@");
        var lenToReplace =
          idEmail % 2 == 0 ? idEmail / 2 : Math.ceil(idEmail / 2);

        this.value.email_nascosta =
          this.value.email_riferimento_vettore.replace(
            this.value.email_riferimento_vettore.slice(
              idEmail - lenToReplace,
              idEmail
            ),
            "*".repeat(lenToReplace)
          );

        //  Nascondo tel
        var len = this.value.telefono_riferimento_vettore.length;
        if (len <= 3) {
          this.value.tel_nascosto = "*".repeat(len);
        } else {
          this.value.tel_nascosto =
            "*".repeat(len - 3) +
            this.value.telefono_riferimento_vettore.slice(-3);
        }
      }
    },
    //  Funzione che scarica le fasce in cui la prenotazione è possibile
    getOrePrenotazione() {
      if (
        this.value.id_tipo_scarico != null &&
        this.value.id_cliente != null &&
        this.value.id_comparto != null
      ) {
        var params = {
          id_tipo_scarico: this.value.id_tipo_scarico,
          id_cliente: this.value.id_cliente,
          id_comparto: this.value.id_comparto,
        };

        this.axios
          .get(
            `${
              this.$store.state.endpoint
            }/ore-prenotazione?${new URLSearchParams(params).toString()}`
          )
          .then((response) => {
            this.oreDisponibili = response.data.fasce.map((el) => {
              el[0] = `${el[0].split(":")[0].padStart(2, "0")}:${el[0]
                .split(":")[1]
                .padStart(2, "0")}`;
              el[1] = `${el[1].split(":")[0].padStart(2, "0")}:${el[1]
                .split(":")[1]
                .padStart(2, "0")}`;

              return {
                text: `${el[0]}-${el[1]}`,
                value: el,
              };
            });
            if (
              (this.value.modifica_prenotazione ||
                this.value.nuova_prenotazione) &&
              this.value.fascia &&
              this.value.fascia.length > 0
            ) {
              var idOrario = [];

              idOrario = this.oreDisponibili.filter(
                (el) => el.value.join(",") == this.value.fascia.join(",")
              );

              if (idOrario.length == 0) {
                this.value.fascia = null;
              }
            }
          })
          .catch((e) => {
            console.log(e);
            this.$store.state.snackbar_text =
              "Non è stato possibile scaricare le ore disponibili per il template";

            if (
              e.response &&
              e.response.data &&
              e.response.data.message &&
              typeof e.response.data.message === "string"
            ) {
              this.$store.state.snackbar_text += ": " + e.response.data.message;
            } else {
              this.$store.state.snackbar_text +=
                ". Verifica la connessione internet o riprova più tardi";
            }

            this.$store.state.snackbar = true;
            this.$store.state.snackbar_color = "error";
            this.oreDisponibili = [];
            this.value.fascia = null;
          });
      } else {
        this.oreDisponibili = [];
        this.value.fascia = null;
      }
    },
    formattedData(data) {
      return new Date(data).toLocaleDateString();
    },
    handleInputTel(ev) {
      this.value.telefono_riferimento_vettore = ev;
    },
    handleInputEmail(ev) {
      this.value.email_riferimento_vettore = ev;
    },
    checkLenNote() {
      if (this.value.note != undefined && this.value.note != null) {
        var text = this.value.note
          .replace(/(?![^\n]{1,75}$)([^\n]{1,75})\s/g, "$1\n")
          .split("\n");

        return text.length < 6 ? true : "Campo troppo lungo";
      } else {
        return true;
      }
    },
    checkLenIndScarico() {
      if (this.value.indicazioni_scarico != undefined && this.value.indicazioni_scarico != null) {
        var text = this.value.indicazioni_scarico
          .replace(/(?![^\n]{1,60}$)([^\n]{1,60})\s/g, "$1\n")
          .split("\n");

        return text.length < 3 ? true : "Campo troppo lungo";
      } else {
        return true;
      }
    },
  },
  computed: {
    //  Filtro gli utenti del vettore in base al vettore scelto
    filteredUsers() {
      //  TODO da affinare in quanto se inserisco il nome di un vettore senza premere sul consigliato conta la scritta come solo testo
      if (
        typeof this.value.rag_soc_vettore == "object" &&
        this.value.rag_soc_vettore != null
      ) {
        return this.value.rag_soc_vettore.users;
      }
      return [];
    },
    periodiDaMostrare() {
      if (this.value.periodi && this.value.periodi.length > 0) {
        return this.value.periodi.slice(
          Math.max(this.value.periodi.length - 4, 0)
        );
      }
      return [];
    },
  },
  watch: {
    "value.id_tipo_scarico": {
      handler() {
        this.getOrePrenotazione();
      },
      immediate: true,
    },
    "value.id_cliente": {
      handler() {
        this.getOrePrenotazione();
      },
      immediate: true,
    },
    "value.id_comparto": {
      handler() {
        this.getOrePrenotazione();
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.fake-card-title {
  color: rgba(0, 0, 0, 0.87);
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
}
.fake-elevation {
  box-shadow: 0px -3px 1px -2px rgba(0, 0, 0, 0.2),
    0px -2px 2px 0px rgba(0, 0, 0, 0.14), 0px -1px 5px 0px rgba(0, 0, 0, 0.12);
}
</style>